import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Input } from 'components/atoms/input';
import { Modal } from 'components/atoms/modal';
import { queueMacrotask } from 'utils/macrotask';

interface Props {
  initialContent: string;
  onDone: (c: string) => void;
  onCancel: () => void;
  visible?: boolean;
  title?: React.ReactNode;
}

export const SpotlightModal: React.FC<Props> = ({
  initialContent,
  onDone,
  onCancel,
  visible,
  title,
}) => {
  const [state, setState] = useState(initialContent);

  const defaultTitle = useMemo(
    () => (
      <FormattedMessage
        id={
          initialContent
            ? 'spotlight.edit_modal.title'
            : 'spotlight.create_modal.title'
        }
      />
    ),
    [initialContent],
  );

  const onOk = useCallback(() => {
    queueMacrotask(() => {
      onDone(state);
    });
  }, [onDone, state]);

  const onCancelCallback = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <Modal
      visible={visible}
      title={title ?? defaultTitle}
      onOk={onOk}
      onCancel={onCancelCallback}
    >
      <Input
        defaultValue={state}
        onBlur={(event) => setState(event.target.value)}
      />
    </Modal>
  );
};
